import { render, staticRenderFns } from "./sucess.vue?vue&type=template&id=2d8f8a2b&scoped=true"
import script from "./sucess.vue?vue&type=script&lang=ts"
export * from "./sucess.vue?vue&type=script&lang=ts"
import style0 from "./sucess.vue?vue&type=style&index=0&id=2d8f8a2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f8a2b",
  null
  
)

export default component.exports